export default __webpack_public_path__ + "static/UiPath-Homepage-Hero-Image-Mobile-953d312a54f37964ee93f3b2858859d3.png";